<template>
  <div class="admin-view-jira-page">
    <div class="full-wrapper">
      <div class="main-custom-row">
        <div class="main-left">
          <div class="view-jira-ticket-section">
            <div class="jira-breadcrumb-box">
              <a href="javascript:void(0);">{{
                issueDetail.fields?.project?.name || "Project"
              }}</a>
              <span>{{ issueDetail.key }}</span>
            </div>
            <h1 class="jira-ticket-title">
              {{ issueDetail.fields?.summary || "Loading..." }}
            </h1>
            <div class="jira-ticket-tabs">
              <div class="jira-ticket-tabs-top">
                <div class="nav" id="nav-tab" role="tablist">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'details' }"
                    @click="activeTab = 'details'"
                    type="button"
                    role="tab"
                  >
                    {{ "Details" }}
                  </button>
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'comments' }"
                    @click="activeTab = 'comments'"
                    type="button"
                    role="tab"
                  >
                    {{ "Comments" }}
                  </button>
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'worklog' }"
                    @click="activeTab = 'worklog'"
                    type="button"
                    role="tab"
                  >
                    {{ "Work Log" }}
                  </button>
                </div>
              </div>
              <div class="jira-ticket-tabs-btm">
                <div class="jira-ticket-tabs-btm-left">
                  <div class="tab-content" id="nav-tabContent">
                    <div
                      class="tab-pane fade"
                      :class="{ 'show active': activeTab === 'details' }"
                      id="jiraTabOne"
                      role="tabpanel"
                      aria-labelledby="jira-tab-one"
                    >
                      <div class="jira-details-tabs-content">
                        <div
                          class="jira-details-white-bg jira-details-top-info"
                        >
                          <ul>
                            <li>
                              <span class="span-label">
                                {{ constants.TYPE_LABEL }}
                                :</span
                              >
                              <span class="span-value"
                                ><img
                                  :src="issueDetail.fields?.issuetype?.iconUrl || '@/assets/lems-v1/images/viewavatar.svg'"
                                  alt=""
                                />
                                {{ issueDetail.fields?.issuetype?.name || "Unknown" }}</span
                              >
                            </li>
                            <li>
                              <span class="span-label">
                                {{ constants.STATUS_LABEL }}
                                :</span
                              >
                              <span class="span-value">{{ issueDetail.fields?.status?.name || "Unknown" }}</span>
                            </li>
                            <li>
                              <span class="span-label">
                                {{ constants.PRIORITY_LABEL }}
                                :</span
                              >
                              <span class="span-value"
                                ><img
                                  :src="issueDetail.fields?.priority?.iconUrl || '@/assets/lems-v1/images/major.svg'"
                                  alt=""
                                />
                                {{ issueDetail.fields?.priority?.name || "Unknown" }}</span
                              >
                            </li>
                            <li>
                              <span class="span-label">
                                {{ constants.AFFECTS_VERSION_LABEL }}
                                :</span
                              >
                              <span class="span-value">{{ getVersions(issueDetail.fields?.versions) }}</span>
                            </li>
                            <li>
                              <span class="span-label">
                                {{ constants.LABELS_LABEL }}
                                :</span
                              >
                              <span class="span-value">{{ getLabels(issueDetail.fields?.labels) }}</span>
                            </li>
                            <li>
                              <span class="span-label">
                                {{ constants.FIX_VERSION_LABEL }}
                                :</span
                              >
                              <span class="span-value">{{ getVersions(issueDetail.fields?.fixVersions) }}</span>
                            </li>
                            <li>
                              <span class="span-label">
                                {{ constants.ENVIRONMENT_LABEL }}
                                :</span
                              >
                              <span class="span-value">{{ issueDetail.fields?.environment || "None" }}</span>
                            </li>
                          </ul>
                        </div>
                        <div
                          class="jira-details-white-bg jira-details-description-box"
                        >
                          <h2>
                            {{ constants.DESCRIPTION_TEXT }}
                          </h2>
                          <div class="jira-ticket-description-box">
                            <div v-if="issueDetail.fields?.description" v-html="issueDetail.fields.description"></div>
                            <p v-else>No description provided.</p>
                          </div>
                        </div>
                        <div
                          v-if="issueDetail.attachments && issueDetail.attachments.length > 0"
                          class="jira-details-white-bg jira-details-attachment-box"
                        >
                          <h2>
                            {{ constants.ATTACHMENTS_LABEL }}
                          </h2>
                          <div class="jira-ticket-attachment-box">
                            <div class="attachments-grid">
                              <div 
                                v-for="attachment in issueDetail.attachments" 
                                :key="attachment.id"
                                class="attachment-item"
                              >
                                <div class="attachment-header">
                                  <span class="attachment-filename">{{ attachment.filename }}</span>
                                  <span class="attachment-size">{{ formatFileSize(attachment.size) }}</span>
                                </div>
                                
                                <!-- Image Attachment -->
                                <div v-if="isImageAttachment(attachment)" class="attachment-media">
                                  <img
                                    :src="attachment.content"
                                    :alt="attachment.filename"
                                    class="attachment-image"
                                    @click="openImageModal(attachment)"
                                  />
                          </div>
                                
                                <!-- Video Attachment -->
                                <div v-else-if="isVideoAttachment(attachment)" class="attachment-media">
                                  <video 
                                    controls 
                                    class="attachment-video"
                                    preload="metadata"
                                  >
                                    <source :src="attachment.content" :type="attachment.mimeType">
                                    Your browser does not support the video tag.
                                  </video>
                        </div>
                                
                                <!-- Other File Types -->
                                <div v-else class="attachment-file">
                                  <div class="file-icon">
                                    <i class="fas fa-file"></i>
                                  </div>
                                  <a 
                                    :href="attachment.content" 
                                    target="_blank" 
                                    class="file-download-link"
                                  >
                                    Download {{ attachment.filename }}
                                  </a>
                                </div>
                                
                                <div class="attachment-meta">
                                  <span class="attachment-author">{{ attachment.author?.displayName }}</span>
                                  <span class="attachment-date">{{ formatDate(attachment.created) }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      :class="{ 'show active': activeTab === 'comments' }"
                      id="jiraTabTwo"
                      role="tabpanel"
                      aria-labelledby="jira-tab-two"
                    >
                      <div class="jira-comments-tabs-content">
                        <div class="jira-details-white-bg jira-ticket-comments">
                          <div class="jira-ticket-comments-logs-top">
                            <h2>
                              {{ constants.COMMENTS_TEXT }}
                            </h2>
                            <button
                              class="jira-add-new--btn jira-add-new-btn-comment"
                              @click="showCommentFormHandler"
                            >
                              {{ constants.ADD_COMMENT_BUTTON }}
                            </button>
                          </div>
                          <div
                            :style="{ display: showCommentForm ? 'block' : 'none' }"
                            class="add-new-c-l-form-section add-new-comment-form-section"
                          >
                            <div class="add-new-c-l-form">
                              <div class="add-new-c-l-form-input">
                                <textarea
                                  v-model="newComment"
                                  placeholder="Add a comment..."
                                  rows="4"
                                  style="
                                    width: 100%;
                                    padding: 10px;
                                    border: 1px solid #ddd;
                                    border-radius: 4px;
                                    resize: vertical;
                                  "
                                ></textarea>
                              </div>
                              <div class="add-new-c-l-form-btns">
                                <button
                                  class="v1-button-outline"
                                  @click="addComment"
                                  :disabled="commentLoading"
                                >
                                  {{
                                    commentLoading
                                      ? "Adding..."
                                      : constants.ADD_BUTTON
                                  }}
                                </button>
                                <button
                                  class="v1-button-outline-black"
                                  @click="hideCommentFormHandler"
                                >
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                              </div>
                            </div>
                          </div>
                          
                          <!-- Edit Comment Form -->
                          <div
                            :style="{ display: showEditCommentForm ? 'block' : 'none' }"
                            class="add-new-c-l-form-section add-new-comment-form-section"
                          >
                            <div class="add-new-c-l-form">
                              <h3 style="margin-bottom: 20px; color: #333;">Edit Comment</h3>
                              <div class="add-new-c-l-form-input">
                                <textarea
                                  v-model="editComment.body"
                                  placeholder="Edit your comment..."
                                  rows="4"
                                  style="
                                    width: 100%;
                                    padding: 10px;
                                    border: 1px solid #ddd;
                                    border-radius: 4px;
                                    resize: vertical;
                                  "
                                ></textarea>
                              </div>
                              <div class="add-new-c-l-form-btns">
                                <button
                                  class="v1-button-outline"
                                  @click="updateComment"
                                  :disabled="editCommentLoading"
                                >
                                  {{
                                    editCommentLoading
                                      ? "Updating..."
                                      : "Update Comment"
                                  }}
                                </button>
                                <button
                                  class="v1-button-outline-black"
                                  @click="hideEditCommentFormHandler"
                                >
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                              </div>
                            </div>
                          </div>
                          
                          <div class="jira-comments-logs-list-section">
                            <div v-if="issueDetail.comments && issueDetail.comments.length > 0">
                              <div 
                                v-for="comment in issueDetail.comments" 
                                :key="comment.id"
                                class="jira-comments-logs-list"
                              >
                              <div class="jira-comments-logs-list-top">
                                <div class="jira-comments-logs-list-top-left">
                                  <div class="jira-comments-logs-list-img">
                                    <img
                                        :src="comment.author?.avatarUrls?.['48x48'] || '@/assets/lems-v1/images/team-members/binod.jpg'"
                                      alt=""
                                    />
                                  </div>
                                  <div class="jira-comments-logs-list-name">
                                      <a href="#">{{ comment.author?.displayName || "Unknown" }}</a>
                                  </div>
                                  <span class="jira-comments-logs-list-type">
                                    {{ constants.ADDED_A_COMMENT_TEXT }}
                                  </span>
                                  <span class="jira-comments-logs-list-time">
                                      {{ formatDate(comment.created) }}
                                  </span>
                                </div>
                                <div class="jira-comments-logs-list-actions">
                                  <ul>
                                    <li>
                                      <button
                                        class="jira-edit-comment-btn"
                                          @click="editCommentHandler(comment)"
                                          :disabled="editCommentLoading || deleteCommentLoading"
                                          title="Edit Comment"
                                      ></button>
                                    </li>
                                    <li>
                                      <button
                                        class="jira-delete-comment-btn"
                                          @click="deleteCommentHandler(comment)"
                                          :disabled="editCommentLoading || deleteCommentLoading"
                                          title="Delete Comment"
                                      ></button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="jira-comments-logs-list-text">
                                  <div v-html="replaceJiraMarkup(comment.body)"></div>
                                </div>
                              </div>
                            </div>
                            <div v-else class="jira-comments-logs-list">
                              <div class="jira-comments-logs-list-text">
                                <p>No comments yet.</p>
                              </div>
                            </div>
                          </div>
                          <div class="jira-comments-logs-load-more">
                            <button class="jira-load-more-btn">
                              {{ constants.LOAD_MORE_BUTTON }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      :class="{ 'show active': activeTab === 'worklog' }"
                      id="jiraTabThree"
                      role="tabpanel"
                      aria-labelledby="jira-tab-three"
                    >
                      <div class="jira-work-log-tabs-content">
                        <div class="jira-details-white-bg jira-ticket-logs">
                          <div class="jira-ticket-comments-logs-top">
                            <h2>
                              {{ constants.WORK_LOG_TEXT }}
                            </h2>
                            <button
                              class="jira-add-new--btn jira-add-new-btn-logs"
                              @click="showWorklogFormHandler"
                            >
                              {{ constants.LOG_WORK_BUTTON }}
                            </button>
                          </div>
                          <div
                            class="add-new-c-l-form-section add-new-logs-form-section"
                            :style="{ display: showWorklogForm ? 'block' : 'none' }"
                          >
                            <div class="add-new-c-l-form">
                              <div class="add-new-c-l-form-input-box">
                                <label>
                                  {{ constants.TIME_SPENT_LABEL }}
                                  <i>*</i>
                                </label>
                                <div class="add-new-c-l-form-input">
                                  <div class="add-new-c-l-form-input-with-txt">
                                    <input
                                      id="timeSpentInput"
                                      type="text"
                                      v-model="newWorklog.timeSpent"
                                      placeholder=""
                                    />
                                    <span>(eg. 3w 4d 12h)</span>
                                  </div>
                                </div>
                              </div>

                              <div class="add-new-c-l-form-input-box">
                                <label>
                                  {{ constants.DATE_STARTED_LABEL }}
                                  <i>*</i>
                                </label>
                                <div class="add-new-c-l-form-input">
                                  <div class="admin-date-input">
                                    <datepicker 
                                      v-model="newWorklog.started" 
                                      id="dateStartedInput" 
                                      class="date-icon" 
                                      placeholder="Select Date"
                                      :max-date="new Date()"
                                      :enable-time-picker="false"
                                      format="yyyy-MM-dd">
                                    </datepicker>
                                  </div>
                                </div>
                              </div>

                              <div class="add-new-c-l-form-input-box">
                                <label>
                                  {{ constants.WORK_DESCRIPTION_LABEL }}
                                </label>
                                <div class="add-new-c-l-form-input">
                                  <textarea
                                    v-model="newWorklog.comment"
                                    placeholder="Add work description..."
                                    rows="3"
                                    style="
                                      width: 100%;
                                      padding: 10px;
                                      border: 1px solid #ddd;
                                      border-radius: 4px;
                                      resize: vertical;
                                    "
                                  ></textarea>
                                </div>
                              </div>
                              <div class="add-new-c-l-form-btns">
                                <button
                                  class="v1-button-outline"
                                  @click="addWorklog"
                                  :disabled="worklogLoading"
                                >
                                  {{
                                    worklogLoading
                                      ? "Adding..."
                                      : constants.ADD_BUTTON
                                  }}
                                </button>
                                <button
                                  class="v1-button-outline-black"
                                  @click="hideWorklogFormHandler"
                                >
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                              </div>
                            </div>
                          </div>
                          
                          <!-- Edit Worklog Form -->
                          <div
                            class="add-new-c-l-form-section add-new-logs-form-section"
                            :style="{ display: showEditWorklogForm ? 'block' : 'none' }"
                          >
                            <div class="add-new-c-l-form">
                              <h3 style="margin-bottom: 20px; color: #333;">Edit Work Log</h3>
                              <div class="add-new-c-l-form-input-box">
                                <label>
                                  {{ constants.TIME_SPENT_LABEL }}
                                  <i>*</i>
                                </label>
                                <div class="add-new-c-l-form-input">
                                  <div class="add-new-c-l-form-input-with-txt">
                                    <input
                                      id="editTimeSpentInput"
                                      type="text"
                                      v-model="editWorklog.timeSpent"
                                      placeholder=""
                                    />
                                    <span>(eg. 3w 4d 12h)</span>
                                  </div>
                                </div>
                              </div>

                              <div class="add-new-c-l-form-input-box">
                                <label>
                                  {{ constants.DATE_STARTED_LABEL }}
                                  <i>*</i>
                                </label>
                                <div class="add-new-c-l-form-input">
                                  <div class="admin-date-input">
                                    <datepicker 
                                      v-model="editWorklog.started" 
                                      id="editDateStartedInput" 
                                      class="date-icon" 
                                      placeholder="Select Date"
                                      :max-date="new Date()"
                                      :enable-time-picker="false"
                                      format="yyyy-MM-dd">
                                    </datepicker>
                                  </div>
                                </div>
                              </div>

                              <div class="add-new-c-l-form-input-box">
                                <label>
                                  {{ constants.WORK_DESCRIPTION_LABEL }}
                                </label>
                                <div class="add-new-c-l-form-input">
                                  <textarea
                                    v-model="editWorklog.comment"
                                    placeholder="Add work description..."
                                    rows="3"
                                    style="
                                      width: 100%;
                                      padding: 10px;
                                      border: 1px solid #ddd;
                                      border-radius: 4px;
                                      resize: vertical;
                                    "
                                  ></textarea>
                                </div>
                              </div>
                              <div class="add-new-c-l-form-btns">
                                <button
                                  class="v1-button-outline"
                                  @click="updateWorklog"
                                  :disabled="editWorklogLoading"
                                >
                                  {{
                                    editWorklogLoading
                                      ? "Updating..."
                                      : "Update Work Log"
                                  }}
                                </button>
                                <button
                                  class="v1-button-outline-black"
                                  @click="hideEditWorklogFormHandler"
                                >
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                              </div>
                            </div>
                          </div>
                          
                          <div class="jira-comments-logs-list-section">
                            <div v-if="issueDetail.worklogs && issueDetail.worklogs.length > 0">
                              <div 
                                v-for="worklog in issueDetail.worklogs" 
                                :key="worklog.id"
                                class="jira-comments-logs-list"
                              >
                              <div class="jira-comments-logs-list-top">
                                <div class="jira-comments-logs-list-top-left">
                                  <div class="jira-comments-logs-list-img">
                                    <img
                                        :src="worklog.author?.avatarUrls?.['48x48'] || '@/assets/lems-v1/images/team-members/ashok.jpg'"
                                      alt=""
                                    />
                                  </div>
                                  <div class="jira-comments-logs-list-name">
                                      <a href="#">{{ worklog.author?.displayName || "Unknown" }}</a>
                                  </div>
                                  <span class="jira-comments-logs-list-type">
                                    {{ constants.LOGGED_WORK_TEXT }}
                                  </span>
                                  <span class="jira-comments-logs-list-time">
                                      {{ formatDate(worklog.started) }}
                                  </span>
                                </div>
                                <div class="jira-comments-logs-list-actions">
                                  <ul>
                                    <li>
                                      <button
                                        class="jira-edit-comment-btn"
                                          @click="editWorklogHandler(worklog)"
                                          :disabled="editWorklogLoading || deleteWorklogLoading"
                                          title="Edit Work Log"
                                      ></button>
                                    </li>
                                    <li>
                                      <button
                                        class="jira-delete-comment-btn"
                                          @click="deleteWorklogHandler(worklog)"
                                          :disabled="editWorklogLoading || deleteWorklogLoading"
                                          title="Delete Work Log"
                                      ></button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="jira-time-spent">
                                <label>{{ constants.TIME_SPENT_LABEL }}</label>
                                  {{ worklog.timeSpent || formatTime(worklog.timeSpentSeconds) }}
                              </div>
                              <div class="jira-comments-logs-list-text">
                                  <div v-if="worklog.comment" v-html="replaceJiraMarkup(worklog.comment)"></div>
                                  <p v-else>No description provided.</p>
                                </div>
                              </div>
                            </div>
                            <div v-else class="jira-comments-logs-list">
                              <div class="jira-comments-logs-list-text">
                                <p>No work logs yet.</p>
                              </div>
                            </div>
                          </div>
                          <div class="jira-comments-logs-load-more">
                            <button class="jira-load-more-btn">
                              {{ constants.LOAD_MORE_BUTTON }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="jira-ticket-tabs-btm-right">
                  <div class="sm-people-assignees-reporter">
                    <h4>{{ "People" }}</h4>
                    <div class="people-assignees-box">
                      <h5>{{ "Assignee" }}</h5>
                      <div class="people-assignees-reporter-box">
                        <div class="people-assignees-reporter-img">
                          <img
                            :src="
                              issueDetail.fields?.assignee?.avatarUrls?.[
                                '48x48'
                              ] || '@/assets/lems-v1/images/person.svg'
                            "
                            alt=""
                          />
                        </div>
                        <div class="people-assignees-reporter-name">
                          {{
                            issueDetail.fields?.assignee?.displayName ||
                            "Unassigned"
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="people-reporter-box">
                      <h5>{{ "Reporter" }}</h5>
                      <div class="people-assignees-reporter-box">
                        <div class="people-assignees-reporter-img">
                          <img
                            :src="
                              issueDetail.fields?.reporter?.avatarUrls?.[
                                '48x48'
                              ] || '@/assets/lems-v1/images/person.svg'
                            "
                            alt=""
                          />
                        </div>
                        <div class="people-assignees-reporter-name">
                          {{
                            issueDetail.fields?.reporter?.displayName ||
                            "Unknown"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="sm-jira-ticket-date-box">
                    <h4>{{ "Date" }}</h4>
                    <ul>
                      <li>
                        <span>{{ "Created" }}</span>
                        {{ formatDate(issueDetail.fields?.created) }}
                      </li>
                      <li>
                        <span>{{ "Updated" }}</span>
                        {{ formatDate(issueDetail.fields?.updated) }}
                      </li>
                    </ul>
                  </div>
                  <div class="sm-jira-ticket-time-tracking-box">
                    <h4>{{ "Time Tracking" }}</h4>
                    <div class="jira-time-track-status-box">
                      <div class="jira-time-track-status-box-top">
                        <span class="jira-time-track-status-box-top-title">{{
                          "Estimated"
                        }}</span>
                        <span class="jira-time-track-status-box-top-time">{{
                          formatTime(issueDetail.fields?.timeestimate)
                        }}</span>
                      </div>
                      <div class="jira-time-track-status-box-progress">
                        <div
                          :style="{
                            width: getEstimatedProgress() + '%',
                            backgroundColor: '#0066BB',
                          }"
                          class="jira-time-track-status-box-progress-bar"
                        ></div>
                      </div>
                    </div>
                    <div class="jira-time-track-status-box">
                      <div class="jira-time-track-status-box-top">
                        <span class="jira-time-track-status-box-top-title">{{
                          "Remaining"
                        }}</span>
                        <span class="jira-time-track-status-box-top-time">{{
                          formatTime(
                            issueDetail.fields?.timeestimate -
                              issueDetail.fields?.timespent
                          )
                        }}</span>
                      </div>
                      <div class="jira-time-track-status-box-progress">
                        <div
                          :style="{
                            width: getRemainingProgress() + '%',
                            backgroundColor: '#E5843A',
                          }"
                          class="jira-time-track-status-box-progress-bar"
                        ></div>
                      </div>
                    </div>
                    <div class="jira-time-track-status-box">
                      <div class="jira-time-track-status-box-top">
                        <span class="jira-time-track-status-box-top-title">{{
                          "Logged"
                        }}</span>
                        <span class="jira-time-track-status-box-top-time">{{
                          formatTime(issueDetail.fields?.timespent)
                        }}</span>
                      </div>
                      <div class="jira-time-track-status-box-progress">
                        <div
                          :style="{
                            width: getLoggedProgress() + '%',
                            backgroundColor: '#7FBA00',
                          }"
                          class="jira-time-track-status-box-progress-bar"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-right">
          <Issues></Issues>
          <Activity></Activity>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL } from "@/config/api.config";
import Issues from "@/components/lems-v1/issues.vue";
import Activity from "@/components/lems-v1/activity.vue";
import Swal from "sweetalert2";
import Datepicker from 'vue3-datepicker';

interface IssueDetail {
  id: string;
  key: string;
  self: string;
  fields: {
    summary: string;
    description: string;
    issuetype: {
      name: string;
      iconUrl: string;
    };
    status: {
      name: string;
    };
    priority: {
      name: string;
      iconUrl: string;
    };
    assignee: {
      displayName: string;
      avatarUrls: {
        [key: string]: string;
      };
    };
    reporter: {
      displayName: string;
      avatarUrls: {
        [key: string]: string;
      };
    };
    project: {
      name: string;
    };
    created: string;
    updated: string;
    timeestimate: number;
    timespent: number;
    environment: string;
    labels: string[];
    versions: any[];
    fixVersions: any[];
  };
  comments: any[];
  worklogs: any[];
  attachments: any[];
}

export default defineComponent({
  name: "IssueDetails",
  components: {
    Issues,
    Activity,
    Datepicker,
  },
  data() {
    return {
      constants,
      issueDetail: {} as IssueDetail,
      activeTab: "details",
      newComment: "",
      newWorklog: {
        timeSpent: "",
        started: null as Date | null,
        comment: "",
      },
      editWorklog: {
        id: "",
        timeSpent: "",
        started: null as Date | null,
        comment: "",
      },
      editComment: {
        id: "",
        body: "",
      },
      loading: false,
      commentLoading: false,
      worklogLoading: false,
      editWorklogLoading: false,
      deleteWorklogLoading: false,
      editCommentLoading: false,
      deleteCommentLoading: false,
      showCommentForm: false,
      showWorklogForm: false,
      showEditWorklogForm: false,
      showEditCommentForm: false,
      editingWorklogId: null as string | null,
      editingCommentId: null as string | null,
    };
  },
  computed: {
    issueKey() {
      return this.$route.params.issueKey as string;
    }
  },
  mounted() {
    this.getIssueDetails();
    this.setDefaultWorklogDate();
  },
  watch: {
    // Watch for changes in the route parameter
    '$route.params.issueKey': {
      handler(newKey, oldKey) {
        if (newKey !== oldKey) {
          // Reset component state when navigating to a different issue
          this.resetComponentState();
          this.getIssueDetails();
          this.setDefaultWorklogDate();
        }
      },
      immediate: true
    }
  },
  methods: {
    async getIssueDetails() {
      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.issueKey) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Missing username or issue key.",
        });
        return;
      }

      this.loading = true;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/jira/issue/${username}/${this.issueKey}/`
        );

        this.issueDetail = response.data.issue;
        console.log("Issue details:", this.issueDetail);
        console.log("Comments:", this.issueDetail.comments);
        console.log("Worklogs:", this.issueDetail.worklogs);

        // Check if comments and worklogs are arrays
        if (!Array.isArray(this.issueDetail.comments)) {
          this.issueDetail.comments = [];
        }
        if (!Array.isArray(this.issueDetail.worklogs)) {
          this.issueDetail.worklogs = [];
        }
      } catch (error) {
        console.error("Error fetching issue details:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load issue details. Please try again.",
        });
      } finally {
        this.loading = false;
      }
    },

    async addComment() {
      // Validation
      if (!this.newComment.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please enter a comment.",
        });
        return;
      }

      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.issueKey) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Missing username or issue key. Please refresh the page.",
        });
        return;
      }

      this.commentLoading = true;
      try {
        const response = await axios.post(
          `${API_BASE_URL}/jira/issue/${username}/${this.issueKey}/comment/`,
          { comment: this.newComment.trim() },
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (response.data && response.data.message) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Comment added successfully!",
            timer: 2000,
            showConfirmButton: false
        });
        }

        // Reset form
        this.showCommentForm = false;
        this.newComment = "";

        // Refresh issue details to show the new comment
        await this.getIssueDetails();
      } catch (error: any) {
        console.error("Error adding comment:", error);
        
        let errorMessage = "Failed to add comment. Please try again.";
        
        if (error.response) {
          // Server responded with error status
          if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.status === 401) {
            errorMessage = "Authentication failed. Please login again.";
          } else if (error.response.status === 403) {
            errorMessage = "You don't have permission to add comments to this issue.";
          } else if (error.response.status === 404) {
            errorMessage = "Issue not found. Please refresh the page.";
          }
        } else if (error.request) {
          // Network error
          errorMessage = "Network error. Please check your connection and try again.";
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        this.commentLoading = false;
      }
    },

    async addWorklog() {
      // Validation
      if (!this.newWorklog.timeSpent.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please enter time spent (e.g., 2h 30m, 1d, 3w).",
        });
        return;
      }

      if (!this.newWorklog.started) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please select a start date.",
        });
        return;
      }

      // Validate time format (basic validation)
      const timeSpentRegex = /^(\d+[wdhm]?\s*)+$/i;
      if (!timeSpentRegex.test(this.newWorklog.timeSpent.trim())) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Time Format",
          text: "Please enter time in valid format (e.g., 2h 30m, 1d, 3w 4d 12h).",
        });
        return;
      }

      // Validate date
      const selectedDate = this.newWorklog.started;
      const today = new Date();
      if (selectedDate > today) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Date",
          text: "Start date cannot be in the future.",
        });
        return;
      }

      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.issueKey) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Missing username or issue key. Please refresh the page.",
        });
        return;
      }

      this.worklogLoading = true;
      try {
        // Format date for API in the required format: "2025-07-17T11:00:00.000+0530"
        const selectedDate = this.newWorklog.started;
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}T11:00:00.000+0530`;
        
        const worklogData = {
          timeSpent: this.newWorklog.timeSpent.trim(),
          started: formattedDate,
          comment: this.newWorklog.comment.trim() || undefined, // Only include comment if not empty
        };

        const response = await axios.post(
          `${API_BASE_URL}/jira/issue/${username}/${this.issueKey}/worklog/`,
          worklogData,
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (response.data && response.data.message) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Work log added successfully!",
            timer: 2000,
            showConfirmButton: false
        });
        }

        // Reset form
        this.showWorklogForm = false;
        this.resetWorklogForm();

        // Refresh issue details to show the new work log
        await this.getIssueDetails();
      } catch (error: any) {
        console.error("Error adding work log:", error);
        
        let errorMessage = "Failed to add work log. Please try again.";
        
        if (error.response) {
          // Server responded with error status
          if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.status === 401) {
            errorMessage = "Authentication failed. Please login again.";
          } else if (error.response.status === 403) {
            errorMessage = "You don't have permission to add work logs to this issue.";
          } else if (error.response.status === 404) {
            errorMessage = "Issue not found. Please refresh the page.";
          } else if (error.response.status === 400) {
            errorMessage = "Invalid work log data. Please check your time format and date.";
          }
        } else if (error.request) {
          // Network error
          errorMessage = "Network error. Please check your connection and try again.";
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        this.worklogLoading = false;
      }
    },

    resetWorklogForm() {
      this.newWorklog = {
        timeSpent: "",
        started: null,
        comment: "",
      };
    },

    resetEditWorklogForm() {
      this.editWorklog = {
        id: "",
        timeSpent: "",
        started: null,
        comment: "",
      };
    },

    // Helper method to set default date for worklog
    setDefaultWorklogDate() {
      if (!this.newWorklog.started) {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        this.newWorklog.started = yesterday;
      }
    },

    // Helper method to validate time format
    validateTimeFormat(timeString: string): boolean {
      const timeSpentRegex = /^(\d+[wdhm]?\s*)+$/i;
      return timeSpentRegex.test(timeString.trim());
    },

    // Helper method to format time for display
    formatTimeForDisplay(timeString: string): string {
      if (!timeString) return '';
      
      // Convert common formats to more readable format
      return timeString
        .replace(/(\d+)w/g, '$1 week$1')
        .replace(/(\d+)d/g, '$1 day$1')
        .replace(/(\d+)h/g, '$1 hour$1')
        .replace(/(\d+)m/g, '$1 minute$1')
        .replace(/s\b/g, 's');
    },

    // Show worklog form with default values
    showWorklogFormHandler() {
      this.showWorklogForm = true;
      this.setDefaultWorklogDate();
    },

    // Hide worklog form and reset
    hideWorklogFormHandler() {
      this.showWorklogForm = false;
      this.resetWorklogForm();
    },

    // Edit worklog methods
    editWorklogHandler(worklog: any) {
      this.editingWorklogId = worklog.id;
      this.editWorklog = {
        id: worklog.id,
        timeSpent: worklog.timeSpent || this.formatTime(worklog.timeSpentSeconds),
        started: worklog.started ? new Date(worklog.started) : null,
        comment: worklog.comment || "",
      };
      this.showEditWorklogForm = true;
    },

    async updateWorklog() {
      // Validation
      if (!this.editWorklog.timeSpent.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please enter time spent (e.g., 2h 30m, 1d, 3w).",
        });
        return;
      }

      if (!this.editWorklog.started) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please select a start date.",
        });
        return;
      }

      // Validate time format
      const timeSpentRegex = /^(\d+[wdhm]?\s*)+$/i;
      if (!timeSpentRegex.test(this.editWorklog.timeSpent.trim())) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Time Format",
          text: "Please enter time in valid format (e.g., 2h 30m, 1d, 3w 4d 12h).",
        });
        return;
      }

      // Validate date
      const selectedDate = this.editWorklog.started;
      const today = new Date();
      if (selectedDate > today) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Date",
          text: "Start date cannot be in the future.",
        });
        return;
      }

      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.issueKey) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Missing username or issue key. Please refresh the page.",
        });
        return;
      }

      this.editWorklogLoading = true;
      try {
        // Format date for API in the required format: "2025-07-17T11:00:00.000+0530"
        const selectedDate = this.editWorklog.started;
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}T11:00:00.000+0530`;
        
        const worklogData = {
          timeSpent: this.editWorklog.timeSpent.trim(),
          started: formattedDate,
          comment: this.editWorklog.comment.trim() || undefined,
        };

        const response = await axios.put(
          `${API_BASE_URL}/jira/issue/${username}/${this.issueKey}/worklog/${this.editWorklog.id}/`,
          worklogData,
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (response.data && response.data.message) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Work log updated successfully!",
            timer: 2000,
            showConfirmButton: false
          });
        }

        // Reset form and hide edit form
        this.showEditWorklogForm = false;
        this.resetEditWorklogForm();
        this.editingWorklogId = null;

        // Refresh issue details to show the updated work log
        await this.getIssueDetails();
      } catch (error: any) {
        console.error("Error updating work log:", error);
        
        let errorMessage = "Failed to update work log. Please try again.";
        
        if (error.response) {
          if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.status === 401) {
            errorMessage = "Authentication failed. Please login again.";
          } else if (error.response.status === 403) {
            errorMessage = "You don't have permission to update work logs for this issue.";
          } else if (error.response.status === 404) {
            errorMessage = "Work log not found. Please refresh the page.";
          } else if (error.response.status === 400) {
            errorMessage = "Invalid work log data. Please check your time format and date.";
          }
        } else if (error.request) {
          errorMessage = "Network error. Please check your connection and try again.";
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        this.editWorklogLoading = false;
      }
    },

    // Delete worklog methods
    async deleteWorklogHandler(worklog: any) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      });

      if (result.isConfirmed) {
        await this.deleteWorklog(worklog.id);
      }
    },

    async deleteWorklog(worklogId: string) {
      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.issueKey) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Missing username or issue key. Please refresh the page.",
        });
        return;
      }

      this.deleteWorklogLoading = true;
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/jira/issue/${username}/${this.issueKey}/worklog/${worklogId}/`
        );

        if (response.data && response.data.message) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Work log deleted successfully!",
            timer: 2000,
            showConfirmButton: false
          });
        }

        // Refresh issue details to show the updated work logs
        await this.getIssueDetails();
      } catch (error: any) {
        console.error("Error deleting work log:", error);
        
        let errorMessage = "Failed to delete work log. Please try again.";
        
        if (error.response) {
          if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.status === 401) {
            errorMessage = "Authentication failed. Please login again.";
          } else if (error.response.status === 403) {
            errorMessage = "You don't have permission to delete work logs for this issue.";
          } else if (error.response.status === 404) {
            errorMessage = "Work log not found. Please refresh the page.";
          }
        } else if (error.request) {
          errorMessage = "Network error. Please check your connection and try again.";
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        this.deleteWorklogLoading = false;
      }
    },

    // Hide edit worklog form
    hideEditWorklogFormHandler() {
      this.showEditWorklogForm = false;
      this.resetEditWorklogForm();
      this.editingWorklogId = null;
    },

    // Show comment form
    showCommentFormHandler() {
      this.showCommentForm = true;
    },

    // Hide comment form and reset
    hideCommentFormHandler() {
      this.showCommentForm = false;
      this.newComment = "";
    },

    // Edit comment methods
    editCommentHandler(comment: any) {
      this.editingCommentId = comment.id;
      this.editComment = {
        id: comment.id,
        body: comment.body || "",
      };
      this.showEditCommentForm = true;
    },

    async updateComment() {
      // Validation
      if (!this.editComment.body.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please enter a comment.",
        });
        return;
      }

      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.issueKey) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Missing username or issue key. Please refresh the page.",
        });
        return;
      }

      this.editCommentLoading = true;
      try {
        const commentData = {
          comment: this.editComment.body.trim(),
        };

        const response = await axios.put(
          `${API_BASE_URL}/jira/issue/${username}/${this.issueKey}/comment/${this.editComment.id}/`,
          commentData,
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (response.data && response.data.message) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Comment updated successfully!",
            timer: 2000,
            showConfirmButton: false
          });
        }

        // Reset form and hide edit form
        this.showEditCommentForm = false;
        this.resetEditCommentForm();
        this.editingCommentId = null;

        // Refresh issue details to show the updated comment
        await this.getIssueDetails();
      } catch (error: any) {
        console.error("Error updating comment:", error);
        
        let errorMessage = "Failed to update comment. Please try again.";
        
        if (error.response) {
          if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.status === 401) {
            errorMessage = "Authentication failed. Please login again.";
          } else if (error.response.status === 403) {
            errorMessage = "You don't have permission to update comments for this issue.";
          } else if (error.response.status === 404) {
            errorMessage = "Comment not found. Please refresh the page.";
          } else if (error.response.status === 400) {
            errorMessage = "Invalid comment data. Please check your comment.";
          }
        } else if (error.request) {
          errorMessage = "Network error. Please check your connection and try again.";
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        this.editCommentLoading = false;
      }
    },

    // Delete comment methods
    async deleteCommentHandler(comment: any) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      });

      if (result.isConfirmed) {
        await this.deleteComment(comment.id);
      }
    },

    async deleteComment(commentId: string) {
      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.issueKey) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Missing username or issue key. Please refresh the page.",
        });
        return;
      }

      this.deleteCommentLoading = true;
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/jira/issue/${username}/${this.issueKey}/comment/${commentId}/`
        );

        if (response.data && response.data.message) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Comment deleted successfully!",
            timer: 2000,
            showConfirmButton: false
          });
        }

        // Refresh issue details to show the updated comments
        await this.getIssueDetails();
      } catch (error: any) {
        console.error("Error deleting comment:", error);
        
        let errorMessage = "Failed to delete comment. Please try again.";
        
        if (error.response) {
          if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.status === 401) {
            errorMessage = "Authentication failed. Please login again.";
          } else if (error.response.status === 403) {
            errorMessage = "You don't have permission to delete comments for this issue.";
          } else if (error.response.status === 404) {
            errorMessage = "Comment not found. Please refresh the page.";
          }
        } else if (error.request) {
          errorMessage = "Network error. Please check your connection and try again.";
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        this.deleteCommentLoading = false;
      }
    },

    // Hide edit comment form
    hideEditCommentFormHandler() {
      this.showEditCommentForm = false;
      this.resetEditCommentForm();
      this.editingCommentId = null;
    },

    resetEditCommentForm() {
      this.editComment = {
        id: "",
        body: "",
      };
    },

    // Reset all component state when navigating to a different issue
    resetComponentState() {
      // Reset issue detail
      this.issueDetail = {} as IssueDetail;
      
      // Reset active tab
      this.activeTab = "details";
      
      // Reset comment form
      this.newComment = "";
      this.showCommentForm = false;
      this.showEditCommentForm = false;
      this.editingCommentId = null;
      this.resetEditCommentForm();
      
      // Reset worklog form
      this.resetWorklogForm();
      this.resetEditWorklogForm();
      this.showWorklogForm = false;
      this.showEditWorklogForm = false;
      this.editingWorklogId = null;
      
      // Reset loading states
      this.loading = false;
      this.commentLoading = false;
      this.worklogLoading = false;
      this.editWorklogLoading = false;
      this.deleteWorklogLoading = false;
      this.editCommentLoading = false;
      this.deleteCommentLoading = false;
    },

    formatDate(dateString: string) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },

    formatTime(seconds: number) {
      if (!seconds) return "0h";
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);

      if (hours > 0) {
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
      }
      return `${minutes}m`;
    },

    // Utility function to replace Jira markup with actual media
    replaceJiraMarkup(text: string) {
      if (!text || !this.issueDetail.attachments) return text;
      
      // Replace !filename|thumbnail! pattern with actual image/video
      return text.replace(/!([^|!]+)\|thumbnail!/g, (match, filename) => {
        const attachment = this.issueDetail.attachments.find(att => att.filename === filename);
        if (attachment) {
          if (attachment.mimeType?.startsWith('image/')) {
            return `<img src="${attachment.content}" alt="${attachment.filename}" style="max-width: 200px; max-height: 150px; border-radius: 4px; margin: 5px 0;" />`;
          } else if (attachment.mimeType?.startsWith('video/')) {
            return `<video controls style="max-width: 300px; max-height: 200px; border-radius: 4px; margin: 5px 0;"><source src="${attachment.content}" type="${attachment.mimeType}">Your browser does not support the video tag.</video>`;
          }
        }
        return match; // Return original if attachment not found
      });
    },

    // Check if attachment is an image
    isImageAttachment(attachment: any) {
      return attachment.mimeType?.startsWith('image/');
    },

    // Check if attachment is a video
    isVideoAttachment(attachment: any) {
      return attachment.mimeType?.startsWith('video/');
    },

    // Get attachment display type
    getAttachmentType(attachment: any) {
      if (this.isImageAttachment(attachment)) return 'image';
      if (this.isVideoAttachment(attachment)) return 'video';
      return 'file';
    },

    // Format file size
    formatFileSize(bytes: number) {
      if (!bytes) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // Open image in modal
    openImageModal(attachment: any) {
      // You can implement a modal here or use a library like SweetAlert2
      Swal.fire({
        imageUrl: attachment.content,
        imageAlt: attachment.filename,
        showConfirmButton: false,
        showCloseButton: true,
        width: 'auto',
        padding: '0'
      });
    },

    getVersions(versions: any[]) {
      if (!versions || versions.length === 0) return "None";
      return versions.map((v) => v.name).join(", ");
    },

    getLabels(labels: string[]) {
      if (!labels || labels.length === 0) return "None";
      return labels.join(", ");
    },

    getEstimatedProgress() {
      const estimated = this.issueDetail.fields?.timeestimate || 0;
      return estimated > 0 ? 100 : 0;
    },

    getRemainingProgress() {
      const estimated = this.issueDetail.fields?.timeestimate || 0;
      const spent = this.issueDetail.fields?.timespent || 0;
      const remaining = estimated - spent;
      return estimated > 0 ? Math.max(0, (remaining / estimated) * 100) : 0;
    },

    getLoggedProgress() {
      const estimated = this.issueDetail.fields?.timeestimate || 0;
      const spent = this.issueDetail.fields?.timespent || 0;
      return estimated > 0 ? Math.min(100, (spent / estimated) * 100) : 0;
    },
  },
});
</script>

<style scoped>
/* Attachment Styles */
.attachments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.attachment-item {
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 15px;
  background: #f8f9fa;
  transition: box-shadow 0.2s ease;
}

.attachment-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.attachment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e1e5e9;
}

.attachment-filename {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  word-break: break-word;
}

.attachment-size {
  font-size: 12px;
  color: #666;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 4px;
}

.attachment-media {
  margin: 10px 0;
  text-align: center;
}

.attachment-image {
  max-width: 100%;
  max-height: 200px;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.attachment-image:hover {
  transform: scale(1.02);
}

.attachment-video {
  max-width: 100%;
  max-height: 200px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.attachment-file {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background: #fff;
  border: 1px solid #e1e5e9;
  border-radius: 6px;
  margin: 10px 0;
}

.file-icon {
  font-size: 24px;
  color: #6c757d;
}

.file-download-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  word-break: break-word;
}

.file-download-link:hover {
  text-decoration: underline;
}

.attachment-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #e1e5e9;
  font-size: 12px;
  color: #666;
}

.attachment-author {
  font-weight: 500;
}

.attachment-date {
  color: #999;
}

/* Media in comments and worklogs */
.jira-comments-logs-list-text img {
  max-width: 200px;
  max-height: 150px;
  border-radius: 4px;
  margin: 5px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.jira-comments-logs-list-text video {
  max-width: 300px;
  max-height: 200px;
  border-radius: 4px;
  margin: 5px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .attachments-grid {
    grid-template-columns: 1fr;
  }
  
  .attachment-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .attachment-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
}
</style>
